// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1NcFP","overflowing":"ReadFullNote_overflowing__1JkYI"};